import { api } from '@/lib/api/client';
import type { AiCallLogListResponse, AiCallLogDetail, AiCallLogSummary, AiCallLogFilters } from './types';

/**
 * One endpoint, three shapes: a UHID/name search returns
 * AiCallLogSearchResult (linked + possible_leaks groups); otherwise a bare
 * array, or — since this screen sends `page` — the paginated envelope
 * (`{data, page, limit, total, has_more}`, apiResponse.js's opt-in contract).
 * See AICallLogTab.tsx's `isSearchResult`/`rowsOf` for how callers tell them apart.
 */
export const fetchAiCallLog = (filters: AiCallLogFilters) =>
  api.get<AiCallLogListResponse>('/admin/ai-call-log', { query: filters });

export const fetchAiCallLogDetail = (id: number) =>
  api.get<AiCallLogDetail>(`/admin/ai-call-log/${id}`);

export const fetchAiCallLogSummary = () =>
  api.get<AiCallLogSummary>('/admin/ai-call-log/summary');

export const rescanAiCallLog = (range: { from?: string; to?: string }) =>
  api.post<{ scanned: number }>('/admin/ai-call-log/rescan', range);
